module.exports = __webpack_public_path__ + "img/tmb.a656b3a0.svg";